import { useDispatch, useSelector } from 'react-redux'

import { myFunctions } from '../firebase'
import { updateUserProfile } from '../Redux/userSlice'

export const scopes =
  'https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.coursework.me https://www.googleapis.com/auth/classroom.coursework.students https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.profile.photos'

const authorizeGoogleClassroom = async (redirect_uri = null) => {
  try {
    const authURL = await myFunctions.generateAuthUrl({
      redirect_uri: redirect_uri || `${window.location.origin}/onboarding?connect=classroom`,
    })

    window.open(authURL.data, '_self')
  } catch (error) {
    console.log(error)
  }
}

const useGoogleClassroom = () => {
  const dispatch = useDispatch()
  const { auth } = useSelector(state => state.user)

  const submitAssignmentToGoogleClassroom = async ({
    assignment = {},
    scores = {},
    googleUserId = null, // optional to override the user's googleUserId
  }) => {
    try {
      const { googleClassroomUserId = null } = scores
      const googleId = googleUserId || googleClassroomUserId

      if (!googleId)
        return {
          error: true,
          message: 'No Google Classroom ID found',
        }
      const { courseWorkId, maxPoints, owners, courseId } = assignment
      const draftGrade = scores?.score ? (scores?.score / 100) * maxPoints : 0
      const result = await myFunctions.submitAssignmentToGoogleClassroomV2({
        teacherId: owners[0],
        courseId,
        courseWorkId,
        userId: googleId,
        draftGrade,
      })

      return result
    } catch (error) {
      return { error: true, message: error.message }
    }
  }

  const storeGoogleAuthToken = async (code, redirect_uri = null) => {
    const { data } = await myFunctions.storeGoogleAuthToken({
      code,
      redirect_uri: redirect_uri || `${window.location.origin}/onboarding?connect=classroom`,
    })

    if (data.success) {
      dispatch(
        updateUserProfile({
          connectedGoogleClassroom: true,
        }),
      )

      return { success: true }
    } else if (data.error) {
      throw new Error('There was an error connecting your Google Classroom account.', data)
    }
  }

  const listCourses = async () => {
    try {
      const { data } = await myFunctions.listTeacherCourses({
        teacherId: auth.uid,
      })

      return data
    } catch (error) {
      throw new Error('There was an error fetching courses.', error)
    }
  }

  const listTopics = async courseId => {
    try {
      const { data } = await myFunctions.listTopics({
        courseId,
        teacherId: auth.uid,
      })

      return data
    } catch (error) {
      throw new Error('There was an error fetching topics.', error)
    }
  }

  const syncGoogleClassroomSection = async sectionId => {
    try {
      const { data } = await myFunctions.syncGoogleClassroomSection({
        sectionId,
      })

      return data
    } catch (error) {
      throw new Error('There was an error syncing the section.', error)
    }
  }

  const importGoogleClassroomSections = async sectionIds => {
    try {
      const { data } = await myFunctions.importGoogleClassroomSections({
        sectionIds,
      })

      console.log(data)

      return data
    } catch (error) {
      throw new Error('There was an error importing the section.', error)
    }
  }

  const postAssignment = async (courseId, topicId, title, description, dueDate, dueTime, maxPoints) => {
    try {
      const { data } = await myFunctions.postNewAssignment({
        teacherId: auth.uid,
        courseId,
        topicId,
        title,
        description,
        dueDate,
        dueTime,
        maxPoints,
      })

      return data
    } catch (error) {
      throw new Error('There was an error posting the assignment.', error)
    }
  }

  return {
    scopes,
    authorizeGoogleClassroom,
    storeGoogleAuthToken,
    listTopics,
    listCourses,
    postAssignment,
    syncGoogleClassroomSection,
    importGoogleClassroomSections,
    submitAssignmentToGoogleClassroom,
  }
}

export default useGoogleClassroom
